<template>
  <div>
    <b-row>
      <b-col lg="6" order="1">
        <div class="panel-form my-3 my-md-5 f-medium text-center">
          <p class="title text-fail mb-3">แผนเกษียณของคุณไม่สำเร็จ</p>
          <p>เงินออมทั้งหมด ณ วันเกษียณ (บาท)</p>
          <p class="f-size-38 main-color">
            {{ formResponse.profit | numeral("0,0.00") }}
          </p>
          <p class="mt-1">เป้าหมายการออมของคุณ</p>
          <p class="text-yello f-size-20">
            {{ formResponse.retirementMoney | numeral("0,0.00") }}
          </p>

          <div class="mt-5">
            <InputProgressResultNegative
              :value="formResponse.profit"
              :max="formResponse.retirementMoney"
              result="negative"
            />
          </div>
          <p>สถานะแผนเกษียณที่วางไว้</p>
          <p class="text-fail f-size-26 mt-1 mb-2">{{ formResponse.text }}</p>
          <p>ต้องออมเงินเพิ่มเติมอีก (บาท)</p>
          <p class="text-fail f-size-26">
            {{ formResponse.diffSavingAndPredict | numeral("0,0.00") }}
          </p>
        </div>
        <div class="mb-3">
          <p class="f-size-28 f-medium mb-0">แผนเกษียณไม่สำเร็จ</p>
          <div class="div-card">
            <p class="f-size-22 main-color f-medium">
              คุณจำเป็นต้องออมเงินเพิ่ม เพื่อให้มีใช้จ่ายเพียงพอตลอดอายุขัย
            </p>
            ณ วันเกษียณอายุ คุณจะมีเงินออมทั้งหมด
            <span class="main-color"
              >{{ formResponse.profit | numeral("0,0.00") }} บาท</span
            >
            โดยคุณจะต้องออมเพิ่ม
            <span class="text-green"
              >{{ formResponse.diffSavingAndPredict | numeral("0,0.00") }} บาท</span
            >
          </div>
        </div>
        <div class="panel-tips">
          <img src="@/assets/images/Tips.png" class="img-tips" />
          <li>เกษียณอายุช้าลง</li>
          <li>ลดค่าใช้จ่ายต่อเดือนหลังเกษียณ</li>
          <li>ออมเงินเพิ่มขึ้น</li>
          <li>เลือกลงทุนที่ให้ผลตอบแทนเพิ่มขึ้นในช่วงก่อนเกษียณ</li>
        </div>
      </b-col>
      <b-col lg="6" order="3">
        <div class="my-3 mb-md-5 text-center">
          <b-button
            variant="link-main"
            type="button"
            class="mb-3"
            @click="$emit('backStep')"
          >
            ปรับแผนเกษียณอีกครั้ง
          </b-button>
          <b-button
            variant="main"
            type="button"
            block
            @click="$emit('confirmSubmit')"
          >
            ยืนยันผลการวางแผน
          </b-button>
        </div>
      </b-col>
      <b-col
        lg="6"
        class="d-flex align-items-center justify-content-center"
        order="2"
      >
        <img
          src="@/assets/images/Penguin-fail.png"
          class="mt-5 mt-md-0 penguin-fail"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputProgressResultNegative from "@/components/input/InputProgressResultNegative";

export default {
  components: {
    InputProgressResultNegative
  },
  props: {
    formResponse: {
      required: true,
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-form {
  p {
    margin-bottom: 0;
  }
}
.div-card {
  background-color: #fff;
  width: 100%;
  padding: 15px;
  border-radius: 20px;
  border: 4px solid #ff6439;
  box-shadow: 0px 3px 30px #00000021;
}
.panel-tips {
  color: white !important;
  background-color: #fab728;
  width: 100%;
  padding: 15px;
  border-radius: 20px;
  border: 4px solid #ff6439;
  box-shadow: 0px 3px 30px #00000021;
  position: relative;
  margin-top: 75px;
  .img-tips {
    position: absolute;
    width: 150px;
    top: -68px;
    left: -8px;
  }
}
img.penguin-fail {
  width: 80% !important;
}
@media (max-width: 767.98px) {
  .panel-form {
    padding: 15px;
    box-shadow: unset !important;
    border: 0;
  }
  .penguin-fail {
    width: 100% !important;
  }
}
</style>
